<script>
import { Bar } from "vue-chartjs";
import moment from "moment-jalaali";
import numeral from "numeral";

export default {
  props: {
    sourceId: "",
    reportList: Array,
    selectedDateType: Number,
    selectedSearchType: Number,
    backgroundColor: String,
  },

  data() {
    return {
      currentPersianDate: "",
      currentDate: "",
      label: "",
      labels: [],
      datasets: [],
      gorgianDate: new Date(),
    };
  },
  extends: Bar,
  mounted() {
    this.getCurrentDate();
    if (this.sourceId != "") {
      if (this.selectedDateType == 1) this.fetchDailyData();
      else if (this.selectedDateType == 2 || this.selectedDateType == 3) {
        this.fetchMountlyYearlyData();
      }
    }
  },

  methods: {
    loadChart() {
      this.setLableType();
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              label: this.label,
              backgroundColor: this.backgroundColor,
              data: this.datasets,
            },
          ],
        },
        {
          animation: false,
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            labels: {
              fontSize: 14,
            },
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  fontSize: 14,
                  beginAtZero: true,
                  callback: (value, index, values) => {
                    return `${this.converCurrencyFormat(value)}`;
                  },
                },
              },
            ],
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: (tooltipItems, data) => {
                return ` ${this.converCurrencyFormat(tooltipItems.value)}`;
              },
            },
          },
          responsiveAnimationDuration: 5000,
        }
      );
    },
    getCurrentDate() {
      let currentFulldate = new Date();

      // let currentdate =
      //   currentFulldate.getFullYear() +
      //   "/" +
      //   (currentFulldate.getMonth() + 1) +
      //   "/" +
      //   String(currentFulldate.getDate()).padStart(2, "0");

      // let toPersianDate = moment(currentdate).format("jYYYY/jMM/jDD");

      let toPersianDate = moment(this.gorgianDate).format("jYYYY/jMM/jDD");

      let fromPersianDate = toPersianDate.substring(8, 0) + "01";

      this.currentPersianDate = toPersianDate;
    },
    fetchDailyData() {
      this.setDays();
    },
    fetchMountlyYearlyData() {
      this.labels = [];
      this.datasets = [];
      this.labels = this.reportList.map((p) => p.bookingDateShamsi);
      if (this.selectedSearchType == 1)
        this.datasets = this.reportList.map((p) => p.count);
      else this.datasets = this.reportList.map((p) => p.totalPayed);

      this.loadChart();
    },
    convertToMonthDay(date) {
      const pDate = moment(date, "jYYYY/jMM/jDD").format("jMM/jDD");
      return pDate;
    },
    convertToPersianDate(date) {
      if (date === "0001-01-01T00:00:00") return "";
      if (!moment(date).isValid()) return "";
      const pdate = moment(date).format("jYYYY/jMM/jDD");

      return pdate;
    },

    convertDate(date) {
      const mdate = moment(date, "jYYYY/jMM/jDD").format("YYYY/MM/DD");

      return mdate;
    },
    addDays(startDate) {
      const date = moment(startDate, "jYYYY/jMM/jDD")
        .add(1, "days")
        .format("jYYYY/jMM/jDD");
      return date;
    },
    setDays(p) {
      this.labels = [];
      this.datasets = [];

      let startDate = this.currentPersianDate.substring(8, 0) + "01";
      this.labels.push(this.convertToMonthDay(startDate));

      while (startDate != this.currentPersianDate) {
        if (
          this.reportList.find(
            (p) => this.convertToPersianDate(p.bookingDateTime) == startDate
          )
        ) {
          if (this.selectedSearchType == 1) {
            let totalPayed = this.reportList.find(
              (p) => this.convertToPersianDate(p.bookingDateTime) == startDate
            ).count;
            this.datasets.push(totalPayed);
          } else {
            let totalPayed = this.reportList.find(
              (p) => this.convertToPersianDate(p.bookingDateTime) == startDate
            ).totalPayed;
            this.datasets.push(totalPayed);
          }
        } else {
          this.datasets.push(0);
        }
        startDate = this.addDays(startDate);
        this.labels.push(this.convertToMonthDay(startDate));
      }

      this.loadChart();
    },
    converCurrencyFormat(num) {
      return numeral(num).format("0,0");
    },
    setLableType() {
      if (this.selectedSearchType == 1) this.label = "تعداد";
      else if (this.selectedSearchType != 1) this.label = "جمع مبالغ";
    },
  },

  watch: {
    selectedDateType(val) {},
    sourceId(newVal) {},

    reportList(val) {
      if (this.selectedDateType == 1) this.fetchDailyData();
      else if (this.selectedDateType == 2 || this.selectedDateType == 3) {
        this.fetchMountlyYearlyData();
      }
    },

    selectedSearchType(val) {
      this.setLableType();
      if (this.selectedDateType == 1) this.fetchDailyData();
      else if (this.selectedDateType == 2 || this.selectedDateType == 3) {
        this.fetchMountlyYearlyData();
      }
    },
  },
};
</script>
